import React, { ReactNode } from 'react'
import { majorScale, Alert, Button, Pane, Paragraph } from 'evergreen-ui'

interface Props {
  title: string
  messaging?: string | ReactNode
  primaryButton?: {
    children: ReactNode
    onClick?: () => any
  }
}

export type ErrorMessageProps = Props & React.ComponentProps<typeof Pane>

export default class ErrorMessage extends React.PureComponent<ErrorMessageProps> {
  handleClick = () => {
    const { primaryButton } = this.props
    if (primaryButton && typeof primaryButton.onClick === 'function') {
      return primaryButton.onClick()
    }

    window.location.reload()
  }

  render() {
    const { title, messaging, primaryButton, ...paneProps } = this.props

    return (
      <Pane flex="1" marginX="auto" marginY={majorScale(8)} maxWidth={majorScale(60)} {...paneProps}>
        <Alert appearance="card" intent="danger" title={title}>
          <Paragraph>{messaging}</Paragraph>
          {primaryButton && (
            <Button appearance="primary" marginTop={majorScale(1)} onClick={this.handleClick}>
              {primaryButton.children}
            </Button>
          )}
        </Alert>
      </Pane>
    )
  }
}
